(function () {
  // ---------- helpers ----------
  const $  = (sel, root = document) => root.querySelector(sel);
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const deg = (d) => BABYLON.Angle.FromDegrees(d).radians();
  const splitUrl = (u) => {
    const q = u.indexOf('?'), h = u.indexOf('#');
    const cut = x => (x === -1 ? u.length : x);
    const end = Math.min(cut(q), cut(h));
    const base = u.slice(0, end);
    const i = base.lastIndexOf('/');
    return { rootUrl: u.slice(0, i + 1), sceneFilename: u.slice(i + 1) };
  };

  // -------- Robust metal label getter (Material/Metal; selects & swatches) --------
  function getMaterialLabel() {
    const activeSwatch = document.querySelector('.tc-swatch.is-active');
    if (activeSwatch) return (activeSwatch.getAttribute('data-material') || activeSwatch.textContent || '').trim();

    const direct =
      document.querySelector('select[name="options[Material]"]') ||
      document.querySelector('select[name="options[Metal]"]');
    if (direct) return direct.options[direct.selectedIndex]?.text?.trim() || '';

    for (const sel of document.querySelectorAll('form.product_form select')) {
      const labelTxt =
        (sel.getAttribute('aria-label') || '') + ' ' +
        (sel.closest('fieldset')?.querySelector('legend')?.innerText || '') + ' ' +
        (sel.previousElementSibling?.tagName === 'LABEL' ? sel.previousElementSibling.innerText : '');
      if (/(material|metal)/i.test(labelTxt)) return sel.options[sel.selectedIndex]?.text?.trim() || '';
    }

    const variantSel = document.querySelector('form.product_form select[name="id"]');
    if (variantSel) return variantSel.options[variantSel.selectedIndex]?.text?.trim() || '';

    const radios = Array.from(document.querySelectorAll(
      'input[type="radio"][name*="options"][name*="Material"], input[type="radio"][name*="options"][name*="Metal"]'
    ));
    const r = radios.find(x => x.checked);
    if (r) return (r.value || r.getAttribute('data-value') || '').trim();

    return '';
  }

  // ---------- defaults ----------
  const ACCESSORY_URL_DEFAULT = "https://cdn.shopify.com/s/files/1/1574/5909/files/round_bail_w_chain_shopify.stl?v=1756141416";
  const DEFAULTS = { LIFT: 11.6, ACCESSORY_RZ: deg(0), ACCESSORY_SCALE: 1.0 };

  // ---------- Babylon viewer ----------
  function createViewer(canvas, ENV_URL) {
    if (typeof BABYLON === 'undefined') { console.error('[Pendant3D] BABYLON not loaded'); return null; }
    BABYLON.STLFileLoader.DO_NOT_ALTER_FILE_COORDINATES = true;

    const engine = new BABYLON.Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true });
    const scene  = new BABYLON.Scene(engine);
    scene.clearColor = new BABYLON.Color4(1, 1, 1, 1);

    const cam = new BABYLON.ArcRotateCamera("cam", Math.PI/2, Math.PI/2.2, 40, BABYLON.Vector3.Zero(), scene);
    cam.attachControl(canvas, true); cam.panningSensibility = 0;
    const HOME = { alpha: cam.alpha, beta: cam.beta };

    const dir = new BABYLON.DirectionalLight("dir", new BABYLON.Vector3(-1, -2, -1), scene);
    dir.intensity = 1.1;
    const sg = new BABYLON.ShadowGenerator(1024, dir);
    sg.useBlurExponentialShadowMap = true; sg.blurKernel = 32;

    const envTex = BABYLON.CubeTexture.CreateFromPrefilteredData(ENV_URL, scene);
    scene.environmentTexture = envTex; scene.environmentIntensity = 1.25;
    const sky = scene.createDefaultSkybox(envTex, true, 1000); if (sky) sky.isVisible = false;

    const metal = new BABYLON.PBRMaterial("metal", scene);
    Object.assign(metal, {
      metallic: 1, roughness: 0.18, environmentIntensity: 1.35,
      albedoColor: new BABYLON.Color3(1,1,1), reflectivityColor: new BABYLON.Color3(1,1,1)
    });
    metal.enableSpecularAntiAliasing = true;
    metal.clearCoat.isEnabled = true; metal.clearCoat.intensity = 0.6; metal.clearCoat.roughness = 0.05;

    const setMetalByLabel = (label) => {
      const s = (label || '').toLowerCase();
      if (s.includes('rose')) {
        metal.albedoColor = new BABYLON.Color3(0.91,0.61,0.58); metal.roughness = 0.25; metal.clearCoat.roughness = 0.07;
      } else if (s.includes('white') && s.includes('gold')) {
        metal.albedoColor = new BABYLON.Color3(0.93,0.93,0.93); metal.roughness = 0.15; metal.clearCoat.roughness = 0.05;
      } else if (s.includes('gold')) {
        metal.albedoColor = new BABYLON.Color3(1.00,0.84,0.38); metal.roughness = 0.20; metal.clearCoat.roughness = 0.06;
      } else {
        metal.albedoColor = new BABYLON.Color3(0.92,0.92,0.92); metal.roughness = 0.12; metal.clearCoat.roughness = 0.04;
      }
      scene.markAllMaterialsAsDirty(BABYLON.Material.AllDirtyFlag);
    };

    engine.runRenderLoop(() => { if (scene.activeCamera) scene.render(); });
    const onResize = () => engine.resize(); window.addEventListener('resize', onResize);

    let currentMesh = null;

    function frameAndLimit(mesh) {
      mesh.computeWorldMatrix(true);
      const bi = mesh.getBoundingInfo();
      const center = bi.boundingBox.centerWorld.clone();
      mesh.position.subtractInPlace(center);
      const ext = bi.boundingBox.extendSizeWorld;
      const maxDim = Math.max(ext.x, ext.y, ext.z);
      const isMobile = window.matchMedia('(max-width: 480px)').matches;
      cam.radius = maxDim * (isMobile ? 6.4 : 9.0);

      // === ZOOM BIAS (kept) ===
      const wrap = document.getElementById('tc-map-tool');
      const zb = isMobile
        ? parseFloat(wrap?.dataset.zoomBiasMobile ?? '1')
        : parseFloat(wrap?.dataset.zoomBiasDesktop ?? '1');
      if (Number.isFinite(zb) && zb > 0) cam.radius *= zb;

      cam.setTarget(BABYLON.Vector3.Zero()); cam.alpha = HOME.alpha; cam.beta = HOME.beta;
      cam.lowerRadiusLimit = cam.radius * 0.9; cam.upperRadiusLimit = cam.radius * 1.1;
      const clamp = BABYLON.Tools.ToRadians(20);
      cam.lowerAlphaLimit = cam.alpha - clamp; cam.upperAlphaLimit = cam.alpha + clamp;
      cam.lowerBetaLimit  = cam.beta  - clamp; cam.upperBetaLimit  = cam.beta  + clamp;
      mesh.receiveShadows = true; sg.addShadowCaster(mesh);
    }

    // ---------- Progress overlay (kept) ----------
    const gui = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("PendantUI", true, scene);
    const scrim = new BABYLON.GUI.Rectangle("scrim");
    scrim.width = 1; scrim.height = 1; scrim.thickness = 0; scrim.background = "#FFFFFF"; scrim.isVisible = false;
    gui.addControl(scrim);

    const stack = new BABYLON.GUI.StackPanel(); stack.isVertical = true; stack.spacing = 10;
    stack.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
    stack.verticalAlignment   = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
    stack.isVisible = false; gui.addControl(stack);

    const spinner = new BABYLON.GUI.Image("spinner",
      "data:image/svg+xml;utf8," +
      encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" stroke="#e6e6e6" stroke-width="4" fill="none"/><path d="M25 5 a20 20 0 0 1 0 40" stroke="#666" stroke-width="4" fill="none"/></svg>')
    );
    spinner.width = "32px"; spinner.height = "32px"; stack.addControl(spinner);

    const label = new BABYLON.GUI.TextBlock("label", "Crafting your piece…");
    label.color = "#444"; label.fontSize = 18; label.height = "28px"; stack.addControl(label);

    scene.onBeforeRenderObservable.add(() => { if (stack.isVisible) spinner.rotation += engine.getDeltaTime() * 0.015; });

    function showOverlay(text){ scrim.isVisible = true; stack.isVisible = true; if (text) label.text = text; }
    function hideOverlay(){ scrim.isVisible = false; stack.isVisible = false; }
    function hideCurrent(){ if (currentMesh) currentMesh.setEnabled(false); }

    // ---------- Latest-wins STL loader (token guard) ----------
    let loadToken = 0;
    function loadSTL(url) {
      const { rootUrl, sceneFilename } = splitUrl(url);
      const myToken = ++loadToken;
      return new Promise((resolve, reject) => {
        BABYLON.SceneLoader.ImportMesh(
          "", rootUrl, sceneFilename, scene,
          (meshes) => {
            if (myToken !== loadToken) { // stale -> dispose & ignore
              try { meshes?.forEach(m => m.dispose()); } catch(_){}
              return reject(new Error('Stale STL load ignored'));
            }
            if (!meshes || !meshes.length) return reject(new Error('No meshes in STL.'));
            meshes.forEach(m => { if (m.rotation) m.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL); });
            if (currentMesh) currentMesh.dispose();
            currentMesh = meshes[0];
            currentMesh.material = metal;
            currentMesh.setEnabled(true);
            frameAndLimit(currentMesh);
            resolve(currentMesh);
          },
          null,
          (_s, msg, ex) => {
            if (myToken !== loadToken) return reject(new Error('Stale STL load error ignored'));
            reject(ex || new Error(msg || 'STL load error'));
          },
          ".stl"
        );
      });
    }
    function getCurrentToken(){ return loadToken; }

    function dispose(){ window.removeEventListener('resize', onResize); scene.dispose(); engine.dispose(); }

    return {
      scene, metal, setMetalByLabel, loadSTL, hideCurrent, showOverlay, hideOverlay, dispose, engine,
      getCurrentToken
    };
  }

  // ---------- One-accessory manager with mm offsets ----------
  function AccessoryOne(viewer) {
    const scene = viewer.scene;
    let node = null;

    function dispose(){ if (node) { node.getChildMeshes().forEach(m=>m.dispose()); node.dispose(); node=null; } }

    function getBounds(n) {
      const kids = n.getChildMeshes ? n.getChildMeshes(true) : [];
      if (!kids.length) return { center: BABYLON.Vector3.Zero(), ext: BABYLON.Vector3.Zero() };
      let min = new BABYLON.Vector3( Infinity,  Infinity,  Infinity);
      let max = new BABYLON.Vector3(-Infinity, -Infinity, -Infinity);
      for (const m of kids) {
        m.computeWorldMatrix(true);
        const bb = m.getBoundingInfo().boundingBox;
        min = BABYLON.Vector3.Minimize(min, bb.minimumWorld);
        max = BABYLON.Vector3.Maximize(max, bb.maximumWorld);
      }
      return { center: min.add(max).scale(0.5), ext: max.subtract(min).scale(0.5) };
    }

    function importGrouped(url, rot={rx:0,ry:0,rz:0}, pos={x:0,y:0,z:0}, material=null){
      const { rootUrl, sceneFilename } = splitUrl(url);
      return new Promise((resolve, reject) => {
        BABYLON.SceneLoader.ImportMesh(
          "", rootUrl, sceneFilename, scene,
          (meshes) => {
            if (!meshes || !meshes.length) { reject(new Error('No meshes in accessory')); return; }
            const group = new BABYLON.TransformNode('accOne', scene);
            meshes.forEach(m => { m.setParent(group); m.material = material || m.material; m.isVisible = true; m.setEnabled(true); });
            group.rotation.x += rot.rx||0; group.rotation.y += rot.ry||0; group.rotation.z += rot.rz||0;
            group.position.set(pos.x||0, pos.y||0, pos.z||0);
            resolve(group);
          },
          null,
          (_s, msg, ex) => reject(ex || new Error(msg || 'Accessory load error')),
          ".stl"
        );
      });
    }

    async function place(pendant, { lift, tilt, scale, ox, oy, oz }) {
      if (!node) return;
      pendant.computeWorldMatrix(true);
      const pbb = pendant.getBoundingInfo().boundingBox;
      const pendantTopY = pbb.centerWorld.y + pbb.extendSizeWorld.y;

      node.scaling.set(scale, scale, scale);
      node.rotation.z += tilt;

      const b = getBounds(node);
      node.position.x += -b.center.x + (ox || 0);
      node.position.z += -b.center.z + (oz || 0);
      node.position.y += (pendantTopY - b.center.y) + lift + (oy || 0);
    }

    return {
      // Stale-safe accessory placement (token checked before/after)
      async loadAndPlace(pendant, url, ox, oy, oz, expectedToken){
        if (expectedToken != null && expectedToken !== viewer.getCurrentToken?.()) return null;

        dispose();
        const startToken = viewer.getCurrentToken?.();

        const group = await importGrouped(url, {}, {}, viewer.metal);

        if (startToken !== viewer.getCurrentToken?.()) { // stale while loading
          try { group.getChildMeshes().forEach(m=>m.dispose()); group.dispose(); } catch(_){}
          return null;
        }

        node = group;
        await place(pendant, {
          lift: DEFAULTS.LIFT, tilt: DEFAULTS.ACCESSORY_RZ, scale: DEFAULTS.ACCESSORY_SCALE, ox, oy, oz
        });

        if (startToken !== viewer.getCurrentToken?.()) { dispose(); return null; } // stale after placement

        return node;
      },
      dispose
    };
  }

  // ---------- THEME MIRRORING (no price logic here) ----------
  function dispatchAll(el) {
    try { el.dispatchEvent(new Event('input',  { bubbles: true })); } catch(_){}
    try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch(_){}
  }
  function matchOptionText(select, wanted) {
    const W = String(wanted || '').trim().toLowerCase();
    let exact = null, fuzzy = null;
    for (const opt of select.options) {
      const t = String(opt.text || '').trim();
      const tl = t.toLowerCase();
      if (tl === W) { exact = opt; break; }
      if (!fuzzy && (tl.includes(W) || W.includes(tl))) fuzzy = opt;
      if (!exact && /18\s*("|in|inch|inches)/i.test(W) && /18/.test(tl)) fuzzy = opt;
      if (!exact && /28\s*("|in|inch|inches)/i.test(W) && /28/.test(tl)) fuzzy = opt;
      if (!exact && /n\/?a/i.test(W) && /n\/?a/i.test(tl)) fuzzy = opt;
    }
    return exact || fuzzy;
  }
  function mirrorToTheme(optionKind, value) {
    const form = document.querySelector('form.product_form') || document;
    const selects = Array.from(form.querySelectorAll('select[name^="options["]'));
    const radios  = Array.from(form.querySelectorAll('input[type="radio"][name*="options"]'));
    const val = String(value || '').trim();

    const isMaterial = optionKind === 'material';
    const isChain    = optionKind === 'chain';
    const isShape    = optionKind === 'shape';

    for (const sel of selects) {
      const nameAttr = sel.getAttribute('name') || '';
      const inside   = (nameAttr.match(/\[(.+)\]/) || [,''])[1].toLowerCase();

      if (isMaterial && /(material|metal)/i.test(inside)) {
        const opt = matchOptionText(sel, val);
        if (opt) { sel.value = opt.value; dispatchAll(sel); }
      }
      if (isChain && /chain/i.test(inside)) {
        const opt = matchOptionText(sel, val);
        if (opt) { sel.value = opt.value; dispatchAll(sel); }
      }
      if (isShape && /(jewelry|type|size|shape|style)/i.test(inside)) {
        const opt = matchOptionText(sel, val);
        if (opt) { sel.value = opt.value; dispatchAll(sel); }
      }
    }

    for (const r of radios) {
      const nm = r.getAttribute('name') || '';
      const lower = nm.toLowerCase();
      const rv = (r.value || r.getAttribute('data-value') || '').trim();
      const rvL = rv.toLowerCase();

      const ok =
        (isMaterial && /(material|metal)/i.test(lower)) ||
        (isChain && /chain/i.test(lower)) ||
        (isShape && /(jewelry|type|size|shape|style)/i.test(lower));

      if (!ok) continue;

      if (rvL === val.toLowerCase() || rvL.includes(val.toLowerCase()) || val.toLowerCase().includes(rvL)) {
        if (!r.checked) { r.checked = true; dispatchAll(r); }
      }
    }
  }

  // ---------- UI wiring ----------
  function mountUI() {
    const wrapper   = $('#tc-map-tool'); if (!wrapper) return;
    const env       = wrapper.getAttribute('data-env');

    function getAccessory() { return (wrapper.getAttribute('data-accessory') || '').trim() || ACCESSORY_URL_DEFAULT; }
    const getAccOX = () => parseFloat(wrapper.getAttribute('data-accessory-ox') || '0') || 0;
    const getAccOY = () => parseFloat(wrapper.getAttribute('data-accessory-oy') || '0') || 0;
    const getAccOZ = () => parseFloat(wrapper.getAttribute('data-accessory-oz') || '0') || 0;

    const overlay   = $('#pendant3d-overlay');
    const canvas    = overlay?.querySelector('.pendant3d__canvas');
    const openBtn   = $('#tc-btn-open');
    const closeBtn  = $('#tc-btn-close');
    const mapEl     = $('#map');

    let viewer = null;
    let accOne = null;

    function getForm() {
      return document.getElementById('tc-form-' + (wrapper.dataset.tcId || '')) ||
             wrapper.closest('form.product_form') ||
             document.querySelector('form.product_form');
    }

    const onMaterialChange = () => { if (viewer) setTimeout(() => viewer.setMetalByLabel(getMaterialLabel()), 0); };

    // --- NEW: use TCShapeConfig to apply per-shape zoom bias to wrapper dataset ---
    function activeShapeLabel(){
      const t = document.querySelector('.tc-tile.is-active');
      return (t?.getAttribute('data-shape') || t?.textContent || '').trim();
    }
    function applyZoomBiasFromConfig(){
      const name = activeShapeLabel();
      const cfg  = (window.TCShapeConfig && name) ? window.TCShapeConfig[name] : null;
      if (!cfg) return;
      if (cfg.zoomBiasDesktop != null) { wrapper.dataset.zoomBiasDesktop = String(cfg.zoomBiasDesktop); }
      else { delete wrapper.dataset.zoomBiasDesktop; }
      if (cfg.zoomBiasMobile  != null) { wrapper.dataset.zoomBiasMobile  = String(cfg.zoomBiasMobile); }
      else { delete wrapper.dataset.zoomBiasMobile; }
    }

    function openViewer() {
      if (!overlay || !canvas) return;
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      wrapper.classList.add('overlay-open');
      if (mapEl) mapEl.style.pointerEvents = 'none';
      if (openBtn)  openBtn.style.display  = 'none';
      if (closeBtn) closeBtn.style.display = '';

      // NEW: ensure per-shape zoom bias from TCShapeConfig is applied before viewer builds
      applyZoomBiasFromConfig();

      if (!viewer) {
        viewer = createViewer(canvas, env);
        if (!viewer) return;
        accOne = AccessoryOne(viewer);
        viewer.setMetalByLabel(getMaterialLabel());
        setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
        viewer.showOverlay?.('Crafting your piece…');
      }
    }

    function closeViewer() {
      if (!overlay) return;
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      wrapper.classList.remove('overlay-open');
      if (mapEl) mapEl.style.pointerEvents = '';
      if (openBtn)  openBtn.style.display  = '';
      if (closeBtn) closeBtn.style.display = 'none';
    }

    on(openBtn,  'click', openViewer);
    on(closeBtn, 'click', closeViewer);
    on(document, 'keydown', (e) => { if (e.key === 'Escape') closeViewer(); });

    document.addEventListener('change', onMaterialChange);
    document.addEventListener('shopify:variant:change', onMaterialChange);
    document.addEventListener('variant:changed', onMaterialChange);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.tc-swatch'); if (!btn) return;
      const group = btn.closest('.tc-materials-grid') || btn.parentElement;
      if (group) group.querySelectorAll('.tc-swatch.is-active').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');

      const picked = document.getElementById('tc-material-picked-' + (wrapper.dataset.tcId || ''));
      if (picked) picked.textContent = btn.getAttribute('data-material') || btn.textContent.trim();

      const label = btn.getAttribute('data-material') || btn.textContent.trim();
      mirrorToTheme('material', label);
      setTimeout(onMaterialChange, 0);
    });

    const watchSel = (q) => { const el = document.querySelector(q); on(el, 'change', onMaterialChange); };
    watchSel('select[name="options[Material]"]');
    watchSel('select[name="options[Metal]"]');
    watchSel('form.product_form select[name="id"]');

    document.addEventListener('input', onMaterialChange);
    document.addEventListener('click', (e) => {
      if (e.target && e.target.matches(
        'input[type="radio"][name*="options"][name*="Material"], input[type="radio"][name*="options"][name*="Metal"], [role="radio"], [aria-pressed]'
      )) onMaterialChange();
    });

    const productForm = getForm() || document.body;
    const mo = new MutationObserver(() => { onMaterialChange(); });
    mo.observe(productForm, { childList: true, attributes: true, subtree: true });

    document.addEventListener('click', (e) => {
      const pill = e.target.closest('.tc-pills .tc-pill'); if (!pill) return;
      const group = pill.closest('.tc-pills') || pill.parentElement;
      if (group) group.querySelectorAll('.tc-pill.is-active').forEach(x => x.classList.remove('is-active'));
      pill.classList.add('is-active');

      const picked = document.getElementById('tc-chain-picked-' + (wrapper.dataset.tcId || ''));
      if (picked) picked.textContent = pill.getAttribute('data-chain') || pill.textContent.trim();

      mirrorToTheme('chain', pill.getAttribute('data-chain') || pill.textContent.trim());
    });

    // Build start → hide everything & show spinner
    document.addEventListener('tc:pendant-build-start', () => {
      if (!viewer) return;
      viewer.hideCurrent?.();
      accOne?.dispose();
      viewer.showOverlay?.('Crafting your piece…');
    });

    // Pendant ready → load pendant; then accessory (stale-safe via token)
    document.addEventListener('tc:pendant-ready', async (e) => {
      const url = e.detail?.stlUrl; if (!url) return;
      if (!viewer) openViewer();
      viewer.showOverlay?.('Crafting your piece…');

      try {
        const pendantMesh = await viewer.loadSTL(url);
        const tokenAtReady = viewer.getCurrentToken?.();

        const accUrl = getAccessory();
        if (accUrl) {
          try {
            await accOne.loadAndPlace(
              pendantMesh,
              accUrl,
              getAccOX(), getAccOY(), getAccOZ(),
              tokenAtReady
            );
          } catch (accErr) { console.warn('[Pendant3D] Accessory issue:', accErr); }
        }

        if (tokenAtReady !== viewer.getCurrentToken?.()) return; // newer load in flight
        viewer.hideOverlay?.();
        onMaterialChange();
      } catch (err) {
        console.error('[Pendant3D] Pendant load failed:', err);
        accOne?.dispose();
        viewer.showOverlay?.('Failed to load model.');
      }
    });

    // Explicit error → keep canvas blank
    document.addEventListener('tc:pendant-error', (e) => {
      accOne?.dispose();
      viewer?.hideCurrent?.();
      viewer?.showOverlay?.(e.detail?.message || 'Error building pendant.');
    });

    // ===== shape changes (overlay + data-* + next preview inputs) =====
    document.addEventListener('tc-shape-change', (e) => {
      const cfg = e.detail || {}; if (!cfg) return;
      if (cfg.product != null)          wrapper.dataset.product        = cfg.product;
      if (cfg.overlayDesktop != null)   wrapper.dataset.overlayDesktop = cfg.overlayDesktop;
      if (cfg.overlayMobile != null)    wrapper.dataset.overlayMobile  = cfg.overlayMobile;

      if (cfg.desktopScale != null)     wrapper.dataset.desktopScale   = cfg.desktopScale;
      if (cfg.desktopOffsetX != null)   wrapper.dataset.desktopOffsetX = cfg.desktopOffsetX;
      if (cfg.desktopOffsetY != null)   wrapper.dataset.desktopOffsetY = cfg.desktopOffsetY;

      if (cfg.mobileScale != null)      wrapper.dataset.mobileScale    = cfg.mobileScale;
      if (cfg.mobileOffsetX != null)    wrapper.dataset.mobileOffsetX  = cfg.mobileOffsetX;
      if (cfg.mobileOffsetY != null)    wrapper.dataset.mobileOffsetY  = cfg.mobileOffsetY;

      if (cfg.accessory != null)        wrapper.dataset.accessory      = cfg.accessory;
      if (cfg.accessoryOx != null)      wrapper.dataset.accessoryOx    = cfg.accessoryOx;
      if (cfg.accessoryOy != null)      wrapper.dataset.accessoryOy    = cfg.accessoryOy;
      if (cfg.accessoryOz != null)      wrapper.dataset.accessoryOz    = cfg.accessoryOz;

      if (cfg.zoomBiasDesktop != null) { wrapper.dataset.zoomBiasDesktop = cfg.zoomBiasDesktop; } else { delete wrapper.dataset.zoomBiasDesktop; }
      if (cfg.zoomBiasMobile  != null) { wrapper.dataset.zoomBiasMobile  = cfg.zoomBiasMobile;  } else { delete wrapper.dataset.zoomBiasMobile;  }

      try {
        const img = wrapper.querySelector('.tc-overlay'); if (!img) return;
        const mq = window.matchMedia('(max-width: 900px)');
        const mobile = mq.matches;

        const src  = mobile ? wrapper.dataset.overlayMobile  : wrapper.dataset.overlayDesktop;
        const scl  = parseFloat(mobile ? wrapper.dataset.mobileScale  : wrapper.dataset.desktopScale) || 1;
        const offX = parseFloat(mobile ? wrapper.dataset.mobileOffsetX: wrapper.dataset.desktopOffsetX) || 0;
        const offY = parseFloat(mobile ? wrapper.dataset.mobileOffsetY: wrapper.dataset.desktopOffsetY) || 0;

        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.style.transform = `translate(calc(-50% + ${offX}px), calc(-50% + ${offY}px)) scale(${scl})`;
      } catch (_) {}

      if (cfg.title || cfg.shape || cfg.productTitle) {
        const shapeLabel =
          cfg.title || cfg.shape || cfg.productTitle ||
          (document.querySelector('.tc-tile.is-active')?.textContent || '').trim();
        if (shapeLabel) mirrorToTheme('shape', shapeLabel);
      }

      // NEW: if no bias came in via cfg for this shape, apply from TCShapeConfig
      if (cfg.zoomBiasDesktop == null && cfg.zoomBiasMobile == null) {
        applyZoomBiasFromConfig();
      }

      onMaterialChange();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountUI);
  else mountUI();

  window.TCPendantUI = {
    ready(stlUrl){ document.dispatchEvent(new CustomEvent('tc:pendant-ready', { detail: { stlUrl } })); }
  };
})();

